import { ComponentPropsWithoutRef, FC } from 'react';

export type MinusIconProps = ComponentPropsWithoutRef<'svg'>;

export const MinusIcon: FC<MinusIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path d="M3.41829 8.44712V7.53207H12.5817V8.44712H3.41829Z" fill={fill ?? 'currentColor'} />
        </svg>
    );
};
